export const USER_INFO_SET = 'USER_INFO_SET'
export const USER_INFO_REMOVE = 'USER_INFO_REMOVE'
